import axios from 'utils/axios'

class Api {
    constructor(httpClient) {
        this.http = httpClient
        return (Api.instance = Api.instance || this)
    }

    signIn(credentials) {
        return this.http.post('/auth/login', credentials)
    }

    signInToken(queryParams) {
        return this.http.get(`/auth/token-login${queryParams}`)
    }

    logout() {
        return this.http.post('/auth/logout')
    }

    sendResetLink(data) {
        return this.http.post('/auth/send-reset-link', data)
    }

    resetPassword(data) {
        return this.http.post('/auth/change-password', data)
    }

    changePassword(data) {
        return this.http.post('/my-profile/change-password', data)
    }

    updateProfile(data) {
        return this.http.post('/my-profile', data)
    }

    updateDid(value) {
        return this.http.post('/update-did', { number: value })
    }

    getUserInfo() {
        return this.http.get('/get-user-info')
    }

    getRecentCalls(params) {
        return this.http.get('/recent-calls', { params })
    }

    getLastCall() {
        return this.http.get('/get-last-call')
    }

    getDidNumbers(params) {
        return this.http.get('/dids', { params })
    }

    getContacts(filter, params) {
        const endpoint = filter ? `/contacts?filter[search_query]=${filter}` : '/contacts'
        return this.http.get(endpoint, { params })
    }

    searchIntegrationNumber({ number, driver }) {
        return this.http.post('/integrations/search-number', { number, driver })
    }

    createIntegrationContact({ number, driver }) {
        return this.http.post('/integrations/create-contact', { phone: number, driver })
    }
}

export default new Api(axios)
